<template>
  <div>
    <a href="/" class="nav-brand"><span>TX Repair Software</span></a>
    <a href="#" class="menu-toggle" v-if="!isMobile" @click="collapseMenu"
      ><fa icon="bars"
    /></a>
    <div id="header-controls">
      <Notification />
      <el-dropdown>
        <el-avatar
          class="el-dropdown-link"
          :size="35"
          src="/images/default-user.png"
        ></el-avatar>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item
            @click.native="$router.push({ name: 'user_profile' })"
            >Profile</el-dropdown-item
          >
          <el-dropdown-item :divided="true" @click.native="logout">
            Logout
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </div>
</template>

<script>
import Notification from "@/components/Notification";
import { isMobile } from "mobile-device-detect";
export default {
  components: { Notification },
  data: () => ({
    isMobile
  }),
  methods: {
    collapseMenu() {
      this.$store.dispatch("ui/toggleMenu");
    },
    logout() {
      this.$store.dispatch("auth/logout").then(() => {
        // this.$store.commit("auth/clearUser");
        // this.$store.dispatch("alert/clear");
        // this.$router.push("/login");
        window.location.href = "/login";
      });
    }
  },
  mounted() {
    this.$store.dispatch("ui/computeViewport");
    var mainNav = document.getElementById("main-nav");
    if (mainNav.clientWidth < 769) {
      this.collapseMenu();
    }
    if (mainNav)
      document.documentElement.style.setProperty(
        "--main-nav-height",
        `${mainNav.clientHeight}px`
      );
  }
};
</script>

<style lang="scss" scoped>
.nav-brand {
  padding-left: 15px !important;
  padding-right: 15px !important;
}
</style>
<style>
#main-nav.el-header {
  height: auto;
}
</style>
